'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdThumbDown = function MdThumbDown(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 5h6.8v20h-6.8v-20z m-6.6 0c1.8 0 3.4 1.6 3.4 3.4v16.6c0 0.9-0.4 1.7-1.1 2.3l-10.9 11.1-1.8-1.8c-0.5-0.5-0.7-1.1-0.7-1.8v-0.5l1.6-7.7h-10.5c-1.8 0-3.4-1.4-3.4-3.2l0.1-0.2h-0.1v-3.2c0-0.5 0.1-0.9 0.3-1.2l5.1-11.8c0.4-1.1 1.6-2 3-2h15z' })
        )
    );
};

exports.default = MdThumbDown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/thumb-down.js
// module id = 1269
// module chunks = 0